export default {
  SET_NOTICE_DISPLAYED(state) {
    state.noticeDisplayed = true;
  }
};
